import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth.service';
import { CurrentUserService } from 'src/app/core/services/current-user.service';

@Component({
  selector: 'app-cambiar-password',
  imports: [CommonModule,ReactiveFormsModule],
  templateUrl: './cambiar-password.component.html',
  styleUrl: './cambiar-password.component.css',
  standalone: true
})
export class CambiarPasswordComponent implements OnInit {
form: FormGroup;
  loading = false;
  error = '';
  success = '';
  usuarioId: number = 0;
  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private currentUserService: CurrentUserService
  ) {
    this.form = this.fb.group({
      passwordActual: ['', Validators.required],
      nuevaPassword: ['', [Validators.required, Validators.minLength(6)]]
    });
  }
  ngOnInit(): void {
    const userId = this.currentUserService.getUsuarioId();
    if (userId) {
      this.usuarioId += userId;
    } else {
      alert('Debes iniciar sesión para acceder a esta sección.');
      this.router.navigate(['/login']);
    }
  }

  cambiar() {
    if (this.form.invalid) return;

    this.loading = true;
    this.error = '';
    this.success = '';

    this.authService.cambiarPassword(this.usuarioId,this.form.value).subscribe({
      next: () => {
        this.success = 'Contraseña actualizada correctamente.';
        this.loading = false;
        this.form.reset();
      },
      error: () => {
        this.error = 'Error al actualizar la contraseña.';
        this.loading = false;
      }
    });
  }
  volverAtras(): void {
    this.router.navigate(['/dashboard']); 
  }
}
